import { resolveImageUrl } from "@helpers/image.helper";

type Props = {
    size?: "sm" | "md" | "lg",
    name: string,
    amount: number,
    icon?: string,
    useFormat?: boolean,
    color?: "green" | "white" | "accent" | "jacarta-500"
}

export function CoinBadge({ size = "sm", name, amount, icon, useFormat = true, color = "white" }: Props) {
    const imageSize = size == "sm" ? "[.875rem]" : (size == "md" ? "4" : "5")
    const textSize = size == "sm" ? "sm" : (size == "md" ? "md" : "lg")
    const amountStr = formatNumber(amount / 1000000, useFormat)


    return <span className="flex items-center whitespace-nowrap">
        <span data-tippy-content={name}>
            <img className={`mr-1 cursor-pointer h-${imageSize} w-${imageSize}`} src={resolveImageUrl(icon ?? "/src/img/coins/cw-coin.svg")} />
        </span>
        <span className={`text-${textSize} font-medium tracking-tight text-${color}`}>{amountStr} {name}</span>
    </span>
}

function formatNumber(amount: number, useFormat: boolean) {
    if (useFormat) {
        const formatter = Intl.NumberFormat('en-US');
        if (amount < 1_000) {
            return amount.toFixed(2);
        } else if (amount >= 1_000 && amount < 1_000_000) {
            return Math.floor(amount / 1_000).toFixed(2) + 'K';
        } else if (amount >= 1_000_000 && amount < 1_000_000_000) {
            return Math.floor(amount / 1_000_000).toFixed(2) + 'M';
        } else {
            return formatter.format(Math.floor(amount / 1_000_000_000)) + 'B';
        }
    } else {
        return amount.toFixed(2)
    }
}